export default __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.cd668286.woff";